@for (alert of alerts; track alert.id; let i = $index) {
  <app-dialog [stackIndex]="alerts.length - 1 - i" (closed)="dismiss(alert.id)">
    <div header>{{ alert.type }}</div>
    <div content>{{ alert.data.message }}</div>
    <fluent-button (click)="dismiss(alert.id)" actions>OK</fluent-button>
  </app-dialog>
}